import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { Moment } from "moment";
import * as moment from "moment";
import { CoreLanguages } from "../../languages/languages";
import { InternationalisationService } from "../angular-internationalisation";

@Component({
  selector: "date-countdown",
  templateUrl: "./dateCountdown.component.html",
  styleUrls: ["./dateCountdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateCountdownComponent implements OnInit {

  @Input() units: any; // units that must be shown in page. Days | Hours | Minutes | Seconds
  @Input() end: Moment; // end of timer
  @Input() divider: any; // use between Unit number in counter. z.b ':'
  @Input() showZero: Boolean = false; // padleft for numbers
  @Output() reached: EventEmitter<Moment> = new EventEmitter(); // this event raise when counter ends
  private langConfig: any; // set Unit Name base on language
  public wasReached: Boolean = false;
  public displayUnits: any = []; // result Object that included Name and numbers for each Unit

  constructor(private _changeDetectorRef: ChangeDetectorRef, ) {
    _changeDetectorRef.detach();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
    }
  }

  ngOnInit(): void {
    const me = this;
    // load at the start of the page;
    me._displayString();
    // call counter function after each 2 millisecond
    setInterval(() => me._displayString(), 200);
  }

  private _displayString() {
    const me = this;
    if (me.wasReached) {
      return;
    }

    if (typeof me.units === "string") {
      me.units = me.units.split("|").map(u => u.trim());
    }

    const now: Moment = moment();
    const dateDifference: any = me.end.valueOf() - now.valueOf();

    if (dateDifference <= 0 && !me.wasReached) {
      me.wasReached = true;
      me.reached.next(now);
    }

    const lastUnit = me.units[me.units.length - 1],
      unitConstantForMillisecs = {
        days: (1000 * 60 * 60 * 24),
        hours: (1000 * 60 * 60),
        minutes: (1000 * 60),
        seconds: 1000
      },
      unitsLeft = {};
    let totalMillisecsLeft = dateDifference,
      i,
      unit: any;

    me.displayUnits = [];
    for (i in me.units) {
      if (me.units.hasOwnProperty(i)) {

        unit = me.units[i].trim();
        if (unitConstantForMillisecs[unit.toLowerCase()] === false) {
          // $interval.cancel(countDownInterval);
          throw new Error("Cannot repeat unit: " + unit);

        }
        if (unitConstantForMillisecs.hasOwnProperty(unit.toLowerCase()) === false) {
          throw new Error("Unit: " + unit + " is not supported. Please use following units: days, hours, minutes, seconds");
        }

        // If it was reached, everything is zero
        unitsLeft[unit] = (me.wasReached) ? 0 : totalMillisecsLeft / unitConstantForMillisecs[unit.toLowerCase()];

        if (lastUnit === unit) {
          unitsLeft[unit] = Math.ceil(unitsLeft[unit]);
        } else {
          unitsLeft[unit] = Math.floor(unitsLeft[unit]);
        }

        totalMillisecsLeft -= unitsLeft[unit] * unitConstantForMillisecs[unit.toLowerCase()];
        unitConstantForMillisecs[unit.toLowerCase()] = false;

        // If it"s less than 0, round to 0
        unitsLeft[unit] = (unitsLeft[unit] > 0) ? unitsLeft[unit] : 0;

        const unitObject: any = {};
        unitObject.name = unit;
        if (unitObject.name.toLowerCase() === "days") {
          unitObject.unitNumbers = Array.from(String(("00" + unitsLeft[unit]).slice(-3)), String);
        } else {
          unitObject.unitNumbers = Array.from(String(("0" + unitsLeft[unit]).slice(-2)), String);
        }
        me.displayUnits.push(unitObject);
      }
    }

    // custom Language
    me.langConfig = CoreLanguages[InternationalisationService.locale].phCounter_UnitNames;

    // use unit name base on language
    me.displayUnits.forEach(obj => {
      obj.name = me.langConfig[obj.name];
    });

    me.PushChanges();
  }
}
